"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayPickerModal = void 0;
const startOfDay_1 = __importDefault(require("date-fns/startOfDay"));
const startOfMonth_1 = __importDefault(require("date-fns/startOfMonth"));
const react_1 = __importStar(require("react"));
const Modal_1 = __importDefault(require("react-bootstrap/Modal"));
const react_day_picker_1 = __importDefault(require("react-day-picker"));
require("react-day-picker/lib/style.css");
const dateUtils = __importStar(require("../../utils/dateUtils"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const DayPickerYearMonthForm_1 = require("./DayPickerYearMonthForm");
require("./DayPicker.scss");
const DayPickerModal = (props) => {
    var _a;
    /** The visible month in the day picker. */
    const [month, setMonth] = (0, react_1.useState)(props.date);
    function handleDateSelect(date) {
        props.onDateSelect(date ? (0, startOfDay_1.default)(date) : undefined);
    }
    return (react_1.default.createElement(Modal_1.default, { className: "day-picker-modal " + ((_a = props.className) !== null && _a !== void 0 ? _a : ""), show: true, onHide: props.onClose, animation: false, centered: true, size: "sm" },
        react_1.default.createElement(Modal_1.default.Header, { closeButton: true },
            react_1.default.createElement(Modal_1.default.Title, null, props.title)),
        react_1.default.createElement(Modal_1.default.Body, { className: "d-flex flex-column", style: { minHeight: "414px" } },
            react_1.default.createElement(react_day_picker_1.default, { className: "flex-grow-1", numberOfMonths: 1, months: dateUtils.MONTHS, weekdaysLong: dateUtils.WEEKDAYS_LONG, weekdaysShort: dateUtils.WEEKDAYS_SHORT, firstDayOfWeek: 1, fromMonth: (0, startOfMonth_1.default)(props.minDate), toMonth: (0, startOfMonth_1.default)(props.maxDate), month: month, disabledDays: [{ before: props.minDate }, { after: props.maxDate }], captionElement: ({ date }) => (react_1.default.createElement(DayPickerYearMonthForm_1.DayPickerYearMonthForm, { date: date, minYear: props.minDate.getFullYear(), maxYear: props.maxDate.getFullYear(), onChange: setMonth })), onDayClick: handleDateSelect, selectedDays: props.date }),
            react_1.default.createElement("div", { className: "d-flex" },
                react_1.default.createElement(Button_1.default, { className: "text-danger", variant: "link", onClick: () => handleDateSelect() }, "Entfernen"),
                react_1.default.createElement(Button_1.default, { className: "flex-grow-1 ml-3", variant: "primary", onClick: () => handleDateSelect(new Date()) }, "Heute")))));
};
exports.DayPickerModal = DayPickerModal;
